import React from 'react';
import PropTypes from 'prop-types';

import { ProductSortItem, ProductItemSkeleton } from 'features/product/components';
import { propTypeProductSortItemDisplayOptions } from 'features/product/components/propTypes';
import { postRecommendedItemTrack } from 'features/tealium/dynamicYield/api';
import { isDyProductRecommendationsEnabled } from 'features/tealium/dynamicYield/helpers';

import useWidget from './useWidget';

function RecommendedItemsSort ({
	skeletonCount, schemeName, onLoad, productSortItemDisplayOptions
}) {

	const { loaded, widget } = useWidget({ schemeName, onLoad });

	const products = widget.Products;

	if (!loaded) {

		const a = Array(skeletonCount).fill(1);
		// eslint-disable-next-line react/no-array-index-key
		const skeletons = a.map((i, key) => <ProductItemSkeleton key={key} />);

		return (
			<div className="layout-Sort">
				{skeletons}
			</div>
		);

	}

	const onClickProduct = (e, product) => {

		const decisionId = e.currentTarget.closest('[data-decisionid]').getAttribute('data-decisionid');
		const dataSlotId = e.currentTarget.getAttribute('data-slotid');

		if (isDyProductRecommendationsEnabled()) {

			postRecommendedItemTrack({
				SlotId: dataSlotId,
				DecisionId: decisionId
			});

		}

	};

	return (
		<>
			{loaded && products && (
				<div className="layout-Sort" data-scheme={schemeName}>
					{products.map((product) => (
						<ProductSortItem
							product={product}
							key={product.ShortSku}
							displayOptions={productSortItemDisplayOptions}
							handleClickProduct={(e) => onClickProduct(e, product)}
						/>
					))}
				</div>
			)}
		</>
	);

}

RecommendedItemsSort.defaultProps = {
	onLoad: undefined
};

RecommendedItemsSort.propTypes = {
	onLoad: PropTypes.func,
	productSortItemDisplayOptions: propTypeProductSortItemDisplayOptions,
	schemeName: PropTypes.string.isRequired,
	skeletonCount: PropTypes.number.isRequired
};

export default RecommendedItemsSort;
